import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services';
import { APIRoutes } from '@constants';
import { DashboardResponse } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private url = APIRoutes.DASHBOARD;

  constructor(private apiService: ApiService) {}

  public dashboard(): Observable<DashboardResponse> {
    return this.apiService.get(`${this.url}/seller/summary`);
  }

  public commentDashboard(commentText: string): Observable<void> {
    const body = { commentText };
    return this.apiService.post(`${this.url}/seller/comment`, body);
  }
}
